import { Link } from 'react-router-dom';
import { useSettings } from '@/contexts/SettingsContext';
import BrandMark from '@/components/BrandMark';

export const Footer = () => {
  const { showRsvp, showRegistry } = useSettings();
  const links = [
    { to: '/', label: 'Home' },
    { to: '/schedule', label: 'Schedule' },
    { to: '/travel', label: 'Travel' },
    { to: '/faqs', label: 'FAQs' },
    ...(showRegistry ? [{ to: '/registry', label: 'Registry' }] : []),
    ...(showRsvp ? [{ to: '/rsvp', label: 'RSVP' }] : []),
  ];
  const linkCountClass = `site-footer__nav--${links.length}`;

  return (
    <footer data-testid="footer" className="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-[auto_1fr] gap-8 md:gap-16 items-center">
          <BrandMark className="w-48 md:w-56 mx-auto" />

          <div className="text-center md:text-left">
            <p data-testid="footer-signature" className="text-xl md:text-2xl text-forest/75">
              April 24, 2027 · George Peabody Library
            </p>
          </div>
        </div>

        <div className="mt-10 pt-5 border-t border-forest/15 flex flex-col md:flex-row items-center justify-between gap-4">
          <nav className={`site-footer__nav ${linkCountClass}`}>
            {links.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-sm uppercase tracking-[0.13em] font-semibold text-forest/65 hover:text-forest transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <p className="text-xs uppercase tracking-[0.12em] text-forest/50">
            Baltimore, Maryland
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
